export default {
    //根据参数更新整理对象
    updateObj(main, obj, filter = false) {
        for (let key in obj) {
            if (!filter) main[key] = obj[key];
            else(main[key] = obj[key]);
        }
        return main;
    },
    // 获取转换时间
    getTime(val) {
        if (val) {
            var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + "-";
            var M =
                (date.getMonth() + 1 < 10 ?
                    "0" + (date.getMonth() + 1) :
                    date.getMonth() + 1) + "-";
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var time = Y + M + D;
            return time;
        }
    },
    // 获取随机数指定区间
    getRandomIntInclusive(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值 
    },
    //隐藏字符串中间内容（*）
    hideMiddle(str) {
        if (!str) return '';
        if (str.length <= 12) {
            let num1 = Math.ceil(str.length / 3);
            let num2 = Math.floor(str.length / 3);
            return str.substr(0, num2) + "*".repeat(num1) + str.substr(num1 + num2);
        }
        let num1 = 4
        let num2 = str.length - 4
        return str.substr(0, num1) + "*".repeat(10) + str.substr(num2)
    },
    //判断手机号
    checkPhone(value) {
        return /^1[3|4|5|7|8|9][0-9]\d{8}$/.test(value);
    },
    //判断名字
    checkName(value) {
        return /^[\u4e00-\u9fa5]{2,6}$/.test(value);
    },
    //判断QQ
    checkQQ(value) {
        return /^[1-9][0-9]{4,12}$/.test(value);
    },
    //密码校验
    isPassword(value) {
        // return /^[a-zA-Z0-9]{6,15}$/.test(value);
        return true
    },
    //密码校验
    withPassword(value) {
        return /^[0-9]{6}$/.test(value);
    },
    bankNumber(value) {
        value.replace(/\D/g, "").replace(/....(?!$)/g, "$& ");
    },
    //格式化时间
    _formatDate (timeStamp, str = 'yyyy-MM-dd HH:mm:ss') {
        try {
            timeStamp = timeStamp * 1
        } catch {}
        const t = new Date(timeStamp)
        const obj = {
            yyyy: t.getFullYear(),
            yy: ('' + t.getFullYear()).slice(-2),
            M: t.getMonth() + 1,
            MM: ('0' + (t.getMonth() + 1)).slice(-2),
            d: t.getDate(),
            dd: ('0' + t.getDate()).slice(-2),
            H: t.getHours(),
            HH: ('0' + t.getHours()).slice(-2),
            h: t.getHours() % 12,
            hh: ('0' + t.getHours() % 12).slice(-2),
            m: t.getMinutes(),
            mm: ('0' + t.getMinutes()).slice(-2),
            s: t.getSeconds(),
            ss: ('0' + t.getSeconds()).slice(-2),
            w: ['日', '一', '二', '三', '四', '五', '六'][t.getDay()]
        }
        const reg = /([a-z])+/ig
        return str.replace(reg, a => obj[a])
    },
    //数字转换
    _toThousands(num) {
        var result = '', counter = 0;
        num = (num || 0).toString();
        for (var i = num.length - 1; i >= 0; i--) {
            counter++;
            result = num.charAt(i) + result;
            if (!(counter % 3) && i != 0) { result = ',' + result; }
        }
        return result;
    }
}